/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import SummaryCard from '../../common/SummaryCard/SummaryCard';
import { actionTypes } from '../../common/SummaryCard/CardContext';

const useStyles = makeStyles(() => {
  return {
    cardMaxWidth: {
      maxWidth: 'unset',
    },
  };
});

/**
 * TODO: this needs some extra work on the card data collection code: the icon, card title,
 *      card type and similar data should be brought from the uiSchema and automatically
 *      forwarded to this generic card
 *
 * Generic summary card that should cover the simple common summary card cases except the ones that need custom layout.
 * This is a wrapper over the summary card that only exposes a core set of its functionality.
 *
 * @param icon - material UI icon for the header of the card
 * @param cardTitle - localized card title
 * @param entries - array with title value objects representing a simple card line entry
 * @param sectionName - section name with the format 'submission_section' used for the scrolling actions
 * @param isSummary - indicates if the card is part of the summary section or the form
 * @param readOnly - if true, no actions are available on the card (forwarded from the parent usually)
 *
 * @returns {JSX.Element}
 */
export default function GenericCard({ icon, cardTitle, entries, sectionName, isSummary, readOnly, configurableIcon }) {
  const classes = useStyles();

  return (
    <SummaryCard
      Icon={icon}
      cardTitle={cardTitle}
      subheader=""
      entries={entries}
      sectionName={sectionName}
      actionType={isSummary ? null : actionTypes.SUMMARY}
      isSummary={isSummary}
      readOnly={readOnly}
      className={classes}
      configurableIcon={configurableIcon}
    />
  );
}
